import { useEffect, useState } from 'react';
import { DropdownItem } from '../../../../../components/Dropdown/DropdownModels';
import DevicesReportService from '../../../../../services/DevicesReports/DevicesReportService';
import { DevicesReportRequest } from '../../../../../models/DevicesReportModels';

function useAssignDeviceSelectDeviceStep(query: string) {
  const [isLoading, setIsLoading] = useState(false);
  const [deviceOptions, setDeviceOptions] = useState<DropdownItem[]>([]);

  /**
   * Gets the list of devices and creates the options for the autocomplete
   */
  const getDevices = () => {
    setIsLoading(true);
    const requestParams: DevicesReportRequest = {
      page: 0,
      pageSize: 10,
      sort: '',
      sortingType: 'asc',
      filter: query as string,
    };
    DevicesReportService.api.fetchUnassignedDevicesReport(requestParams).then(
      (response) => {
        setIsLoading(false);
        const options = response.data.devices.map((dev) => {
          const serialMatches = dev.serialNumber?.toLowerCase().includes(query.toLowerCase());
          const assetMatches = dev.assetTagNumber?.toLowerCase().includes(query.toLowerCase());

          return {
            value: dev.id,
            label: assetMatches && !serialMatches ? dev.assetTagNumber : dev.serialNumber,
            key: dev.id,
            secondaryLabel: `${dev.manufacturer} ${dev.model}`,
            data: dev,
          } as DropdownItem;
        });
        setDeviceOptions(options);
      },
      () => {
        setIsLoading(false);
      },
    );
  };

  useEffect(() => {
    getDevices();
  }, [query]);

  return { deviceOptions, isLoading };
}

export default useAssignDeviceSelectDeviceStep;
